import { RadioGroup } from "@headlessui/react";
import _, { get, size } from "lodash";
import { DateTime } from "luxon";
import { cn } from "@shared/ui";

const maskPolicyNumber = (policy) => {
  const policyNumber = get(policy, "policyNumber", "");
  const policyNumberLength = size(policyNumber);

  const maskedSubPolicyNumber = "•".repeat(Math.max(policyNumberLength - 4, 0));
  const unmaskedSubPolicyNumber = !_.isEmpty(policyNumber)
    ? policyNumber.substring(
        Math.max(policyNumberLength - 4, 0),
        policyNumberLength
      )
    : "";

  const maskedPolicyNumber = `${maskedSubPolicyNumber} ${unmaskedSubPolicyNumber}`;

  return maskedPolicyNumber;
};

const formatPolicyDate = (policy, field) =>
  get(policy, field)
    ? DateTime.fromISO(get(policy, field, ""), { zone: "utc" }).toLocaleString(
        DateTime.DATE_MED
      )
    : "n/a";

const Policy = ({ policy, onClick }) => {
  const titleCase = (inputString) => {
    return _.startCase(_.toLower(inputString));
  };

  const hasPolicyNumber = !_.isEmpty(get(policy, "policyNumber", ""));
  const maskedPolicyNumber = hasPolicyNumber ? maskPolicyNumber(policy) : "";

  const policyType = titleCase(get(policy, "policyType"));
  const policyHolder = get(policy, "policyHolder", "");
  const policyLabel = get(policy, "policyLabel", "");
  const hasDates =
    Boolean(get(policy, "effectiveDate")) ||
    Boolean(get(policy, "expirationDate"));

  return (
    <RadioGroup.Option
      onClick={onClick}
      value={policy}
      className={({ active, checked }) =>
        cn(
          "flex cursor-pointer items-center gap-4 rounded-lg border p-4 text-ink transition-colors focus:outline-none",
          active && "outline outline-2 outline-offset-2 outline-ink",
          checked
            ? "border-ink bg-surface-muted shadow-[inset_0_0_0_1px_rgb(var(--ax-ink))]"
            : "border-border hover:bg-canvas"
        )
      }
    >
      {({ checked }) => (
        <>
          <div className="flex min-w-0 flex-1 flex-col gap-0.5">
            <h2 className="text-card-title">
              {policyType}
              {hasPolicyNumber ? `  ${maskedPolicyNumber}` : ""}
            </h2>
            {policyHolder ? (
              <p className="text-body-lg text-ink-secondary">{policyHolder}</p>
            ) : null}
            {policyLabel ? (
              <p className="text-body-lg text-ink-secondary">
                {titleCase(policyLabel)}
              </p>
            ) : null}
            {hasDates ? (
              <p className="text-body-lg text-ink-secondary">
                {formatPolicyDate(policy, "effectiveDate")} -{" "}
                {formatPolicyDate(policy, "expirationDate")}
              </p>
            ) : null}
          </div>
          <span
            aria-hidden
            className={cn(
              "flex size-5 shrink-0 items-center justify-center rounded-full border bg-surface",
              checked ? "border-ink" : "border-control"
            )}
          >
            {checked ? (
              <span className="size-2.5 rounded-full bg-ink" />
            ) : null}
          </span>
        </>
      )}
    </RadioGroup.Option>
  );
};

export default Policy;
